export const HttpMethod = Object.freeze({
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
    PATCH: 'PATCH',
    HEAD: 'HEAD',
    OPTIONS: 'OPTIONS',
  });

  export const StatusCode = Object.freeze({
    OK: 200,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
  });

  export const LogLevel = Object.freeze({
    INFO: 'INFO',
    ERROR: 'ERROR',
    WARN : 'WARN',
    DEBUG : 'DEBUG'
  })
  